function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.00204878049 0.0273170732 24.0020488 0.0273170732 24.0020488 24.0273171 0.00204878049 24.0273171"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5546\\u54C1\\u7BA1\\u7406",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5BFC\\u822A",
  transform: "translate(-700.000000, -110.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 950,
  height: 934
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  transform: "translate(652.000000, 96.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "shangpin",
  transform: "translate(48.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9864098,4.84350732 C12.631161,4.04560976 13.7087854,3.74081951 14.6759463,4.08282927 C15.6432439,4.42480488 16.2897707,5.33917561 16.2897707,6.36503415 C16.2897707,7.39089268 15.6432439,8.30536585 14.6759463,8.64737561 C13.7087854,8.98921463 12.631161,8.68445854 11.9864098,7.88666341 C11.3414878,8.68445854 10.2638634,8.98921463 9.29670244,8.64737561 C8.32954146,8.30536585 7.68287805,7.39089268 7.68287805,6.36503415 C7.68287805,5.33917561 8.32954146,4.42480488 9.29670244,4.08282927 C10.2638634,3.74081951 11.3414878,4.04560976 11.9864098,4.84350732 Z",
  id: "Fill-3",
  fill: "#696D82",
  opacity: 0.600000024,
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4415366,6.63431115 C19.525922,6.63325366 20.441761,7.43917561 20.5783463,8.51492195 C20.7149317,9.59066829 20.0297171,10.5999659 18.9794439,10.8699268 L18.9794439,17.8819463 C18.9794439,19.1144244 18.0747024,20.0826439 16.9224,20.0826439 L7.05024878,20.0826439 C5.89794634,20.0826439 4.99320488,19.0702732 4.99320488,17.8824927 L4.99320488,10.8694146 C3.94651707,10.5965171 3.26546829,9.58892683 3.4016439,8.5158439 C3.53799024,7.44276098 4.44939024,6.63738537 5.53114634,6.63431115 L18.4415366,6.63431115 Z M15.0600927,10.092722 C14.7733317,10.092722 14.5684537,10.2562488 14.4866732,10.5434195 C14.1176195,11.5676732 13.133761,12.3466537 11.9864098,12.3466537 C10.8388878,12.3466537 9.85506341,11.5676732 9.48597561,10.5434195 C9.40419512,10.2976 9.15786341,10.092722 8.9125561,10.092722 C8.50266341,10.092722 8.2153561,10.5020683 8.33859024,10.911961 C8.83026341,12.4698878 10.3058976,13.5762976 11.9864098,13.5762976 C13.6668878,13.5762976 15.1423854,12.4698878 15.6340585,10.911961 C15.7572927,10.5020683 15.4699854,10.092722 15.0600927,10.092722 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  fill: "#696D82",
  mask: "url(#mask-2)"
})))));

var SvgItemManagement = function SvgItemManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/itemManagement.24630a99.svg";
export { ForwardRef as ReactComponent };